export default __webpack_public_path__ + "static/media/reconnect.ea1c8f94.svg";